import { ApplicationDetail } from '@/features';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/applications/$detail')({
  component: RouteComponent,
});

function RouteComponent() {
  return <ApplicationDetail />;
}
